import { BaseMapModel } from '@wind-log_library/fe-component-library';

export class Geomap {
  static mapFromPark(parksData: any): BaseMapModel {
    return {
      assets: parksData.data.portfolios[0].parks.map(geomap => ({
        code: geomap.code,
        displayCode: geomap.displayCode || geomap.code,
        lat: geomap.lat,
        lon: geomap.lon,
        fe_name: geomap.fe_name,
        name: geomap.name,
        theoreticalPower: geomap.data.WTUR1_W_theoretical.sum,
        lostPower: geomap.data.WTUR1_W_loss.sum,
        actualPower: geomap.data.WTUR1_W_mag_f.sum,
        ratedPower: geomap.dataDebbug.WTUR1_W_rated.sum,
        status: geomap.data.WTUR1_status.min,
        technology: 'wind',
        subAssets: geomap.turbines.map(turbine => ({
          code: turbine.code,
          name: turbine.name,
          asset_fe_name: geomap.fe_name,
          hubHeight: turbine.hubHeight,
          serialNav: turbine.serialNav,
          serial: turbine.serial,
          type: turbine.type,
          typeDisplayName: turbine.type,
          status: turbine.data && turbine.data.WTUR1_status ? turbine.data.WTUR1_status : 0
        }))
      }))
    };
  }
}
